import {
  CHATROOM_INPUT_WYSIWYG_FULL_SCREEN_MAX_HEIGHT_OFFSET_PX,
  CHATROOM_INPUT_WYSIWYG_FULL_SCREEN_MAX_HEIGHT_VH_FRACTION,
  CHATROOM_INPUT_WYSIWYG_MAX_HEIGHT_OFFSET_PX,
  CHATROOM_INPUT_WYSIWYG_MIN_HEIGHT,
} from '../../../Chatroom.constants'

export function getChatroomInputWysiwygMaxHeight(isFullScreen) {
  if (typeof window === 'undefined') {
    return CHATROOM_INPUT_WYSIWYG_MIN_HEIGHT
  }

  const maxHeight = isFullScreen
    ? window.innerHeight *
        CHATROOM_INPUT_WYSIWYG_FULL_SCREEN_MAX_HEIGHT_VH_FRACTION -
      CHATROOM_INPUT_WYSIWYG_FULL_SCREEN_MAX_HEIGHT_OFFSET_PX
    : window.innerHeight - CHATROOM_INPUT_WYSIWYG_MAX_HEIGHT_OFFSET_PX

  return Math.max(CHATROOM_INPUT_WYSIWYG_MIN_HEIGHT, maxHeight)
}
